import { Application } from '../../models';

export interface IApplicationFilteringService {
    applications(applications?: Application[]): Application[];
    filter(searchString: string): Application[];
}

export class ApplicationFilteringService implements IApplicationFilteringService {
    private apps: Application[];

    static serviceId = 'applicationFilteringService';
    static $inject = [];

    constructor() {
        this.apps = [];
    }

    applications(applications?: Application[]): Application[] {
        if (applications) {
            this.apps = applications;
        }
        return this.apps;
    }

    filter(searchString: string): Application[] {
        let results = [];
        if (searchString === '*' || !searchString) {
            results = this.apps;
        } else {
            results = this.apps.filter(a => a.name.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase()) > -1);
        }
        return results;
    }
}